// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__cJb+4","SocialMedia":"Footer_SocialMedia__zpF-y","Links":"Footer_Links__E6vrJ","CopyRight":"Footer_CopyRight__prAAT"};